import { jsx as _jsx } from "react/jsx-runtime";
import { CircleButton } from "./circleButton";
import * as S from "./colorButton.styles";
export function ColorButton({ color, isDisabled, isSelected, onClick, }) {
    return (_jsx(CircleButton, { isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, children: _jsx(S.Color, { "$color": color }) }));
}
